import React from 'react';
import { format, isSameDay } from "date-fns";
import { DateFormat } from "../../../../Helpers/DateTimeHelper";
import { intervalFromState } from "../../../../Helpers/IntervalHelper";
import { useReschedulerForm } from "./ReschedulerFormProvider";

const RescheduledSummary = (props) => {
    const {mainBookingConfig, occurrence, rescheduledOccurrence} = useReschedulerForm();

    const originalInterval = intervalFromState(occurrence);
    const rescheduledInterval = intervalFromState(rescheduledOccurrence);

    const amenityChanged = () => {
        if (!rescheduledInterval) {
            return false;
        }
        return (mainBookingConfig.amenity_id !== rescheduledOccurrence.amenity_id);
    }

    if (rescheduledOccurrence === false) {
        return (
            <div style={{marginBottom: "0.25rem", paddingLeft: "1rem"}}>
                <div>
                    <i className="fa fa-level-up fa-rotate-90"></i>&nbsp;&nbsp;
                    Occurrence removed
                </div>
            </div>
        );
    }

    if (!rescheduledOccurrence || !rescheduledInterval) {
        return null;
    }

    return (<>
        <div style={{marginBottom: "0.25rem", paddingLeft: "1rem"}}>

            {(rescheduledOccurrence === false) && (
                <div>
                    <i className="fa fa-level-up fa-rotate-90"></i>&nbsp;&nbsp;
                    Occurrence removed
                </div>
            )}

            {(amenityChanged()) && (
                <div>
                    <i className="fa fa-level-up fa-rotate-90"></i>&nbsp;&nbsp;
                    Moved to another amenity
                </div>
            )}

            {(rescheduledInterval.start) && (
                <div>
                    <i className="fa fa-level-up fa-rotate-90"></i>&nbsp;&nbsp;

                    {(isSameDay(originalInterval.start, rescheduledInterval.start))
                        ? <>
                            &nbsp;<span>Moved to</span>&nbsp;
                            <span>
                                {format(rescheduledInterval.start, DateFormat.HUMAN_SLASHED_DATE)}&nbsp;@&nbsp;
                            </span>
                        </>
                        : <>
                            &nbsp;<span>Time changed to</span>&nbsp;
                        </>
                    }

                    <span>
                        {format(rescheduledInterval.start, DateFormat.MYSQL_TIME)}
                        -
                        {format(rescheduledInterval.end, DateFormat.MYSQL_TIME)}&nbsp;
                        {(!isSameDay(originalInterval.start, rescheduledInterval.start)) &&
                            <span>
                                ({format(rescheduledInterval.start, DateFormat.WEEKDAY)})
                            </span>
                        }
                    </span>
                </div>
            )}
        </div>
    </>);
};

RescheduledSummary.propTypes = {};

RescheduledSummary.defaultProps = {};

export default RescheduledSummary;
